import { Navigate, useLocation } from "react-router-dom";
import Cookie from "utils/cookie";

/**
 * Protects routes that require authentication.
 * Redirects to /login if no JWT is present, preserving the intended destination for post-login redirect.
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = !!Cookie.get("jwt");

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
